(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["free-shipping-progress"] && !Shopify.designMode) return;
  try {
    class ProductShippingProgress extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-psp-track]');
      this.message = this.querySelector('[data-psp-message]');
      this.onCartEvent = this.handleCartEvent.bind(this);
      this.onCartSubmit = this.handleCartSubmit.bind(this);

      document.addEventListener('cart:update', this.onCartEvent);
      document.addEventListener('cart:refresh', this.onCartEvent);
      document.addEventListener('cart:change', this.onCartEvent);
      document.addEventListener('cart:add', this.onCartEvent);
      document.addEventListener('submit', this.onCartSubmit, true);

      this.render(Number(this.dataset.cartTotal) || 0, this.dataset.currency);
    }

    disconnectedCallback() {
      document.removeEventListener('cart:update', this.onCartEvent);
      document.removeEventListener('cart:refresh', this.onCartEvent);
      document.removeEventListener('cart:change', this.onCartEvent);
      document.removeEventListener('cart:add', this.onCartEvent);
      document.removeEventListener('submit', this.onCartSubmit, true);
      window.clearTimeout(this.refreshTimer);
    }

    handleCartEvent(event) {
      const cart = event.detail?.cart || event.detail;

      if (cart && Number.isFinite(Number(cart.total_price))) {
        this.render(Number(cart.total_price), cart.currency || this.dataset.currency);
        return;
      }

      this.refreshCart();
    }

    handleCartSubmit(event) {
      if (!event.target.matches('form[action*="/cart/add"]')) return;

      window.clearTimeout(this.refreshTimer);
      this.refreshTimer = window.setTimeout(() => this.refreshCart(), 800);
    }

    async refreshCart() {
      if (this.loading) return;
      this.loading = true;

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });

        if (!response.ok) return;
        const cart = await response.json();
        this.render(Number(cart.total_price) || 0, cart.currency || this.dataset.currency);
      } finally {
        this.loading = false;
      }
    }

    render(cartTotal, currency) {
      const threshold = Number(this.dataset.threshold) || 0;
      const remaining = Math.max(0, threshold - cartTotal);
      const progress = threshold > 0 ? Math.min(100, Math.max(0, (cartTotal / threshold) * 100)) : 0;

      this.style.setProperty('--psp-progress', `${progress}%`);
      this.track?.setAttribute('aria-valuenow', String(Math.round(progress)));

      if (this.message) {
        if (remaining > 0) {
          const [beforeAmount = '', ...afterParts] = this.dataset.remainingTemplate.split('[amount]');
          const amount = document.createElement('strong');
          amount.className = 'product-shipping-progress__amount';
          amount.textContent = this.formatMoney(remaining, currency);

          this.message.replaceChildren(
            document.createTextNode(beforeAmount),
            amount,
            document.createTextNode(afterParts.join('[amount]'))
          );
        } else {
          this.message.textContent = this.dataset.successText;
        }
      }
    }

    formatMoney(cents, currency) {
      const value = (cents / 100).toFixed(2).replace('.', ',');
      if (!currency || currency === 'RON') return `${value} lei`;
      return `${value} ${currency}`;
    }
  }

  if (!customElements.get('product-shipping-progress')) {
    customElements.define('product-shipping-progress', ProductShippingProgress);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["shipping-estimator"] && !Shopify.designMode) return;
  try {
    class ShippingEstimator extends HTMLElement {
    connectedCallback() {
      this.renderEstimate();
    }

    addDays(startDate, numberOfDays, skipWeekends) {
      const date = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
      let addedDays = 0;

      while (addedDays < numberOfDays) {
        date.setDate(date.getDate() + 1);
        const dayOfWeek = date.getDay();

        if (!skipWeekends || (dayOfWeek !== 0 && dayOfWeek !== 6)) {
          addedDays += 1;
        }
      }

      return date;
    }

    renderEstimate() {
      const output = this.querySelector('[data-shipping-estimator-date]');

      if (!output) return;

      const minimumDays = Math.max(0, Number.parseInt(this.dataset.minimumDays, 10) || 0);
      const maximumDays = Math.max(minimumDays, Number.parseInt(this.dataset.maximumDays, 10) || minimumDays);
      const skipWeekends = this.dataset.skipWeekends === 'true';
      const today = new Date();
      const earliestDate = this.addDays(today, minimumDays, skipWeekends);
      const latestDate = this.addDays(today, maximumDays, skipWeekends);
      const locale = document.documentElement.lang || navigator.language || 'en';
      const monthStyle = this.dataset.dateStyle === 'short' ? 'short' : 'long';
      const options = { day: 'numeric', month: monthStyle };

      if (earliestDate.getFullYear() !== today.getFullYear() || latestDate.getFullYear() !== today.getFullYear()) {
        options.year = 'numeric';
      }

      const formatter = new Intl.DateTimeFormat(locale, options);

      if (typeof formatter.formatRange === 'function') {
        output.textContent = formatter.formatRange(earliestDate, latestDate);
      } else {
        output.textContent = `${formatter.format(earliestDate)} – ${formatter.format(latestDate)}`;
      }
    }
  }

  if (!customElements.get('shipping-estimator')) {
    customElements.define('shipping-estimator', ShippingEstimator);
  }
  } catch(e) { console.error(e); }
})();

})();
